<template>

  <div class="p-fluid report-field">
    <div :class="['p-grid report-field-header', {'report-field-header-small':section==='REPORT'}]">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label :for="guide.key">{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
    </div>
    <div>

      <InputText :id="guide.key" v-if="!overview" type="text" v-model="text" 
              :placeholder="$t('report.'+section+'.'+guide.key+'_ph')"
              @input="dataChanged($event.target.value)" 
              :disabled="guide.disabled"
              :class="{'p-invalid':guide.invalid}"/>

      <span v-else>{{ text ?? '-' }}</span>

    </div>
  </div>

    <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>{{$t('report.REPORT.'+guide.key)}}</label>
            
        </div>
    </div> -->

    <!-- <div>mode: {{ guide.mode }}</div>
    <div>type: {{ guide.type }}</div>
    <div>key: {{ guide.key }}</div>
    <div>annotation: {{ guide.annotation }}</div> -->


</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      text: null
    }
  },
  computed: {
  },
  created() {
    this.text = this.data[this.guide.key];
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(newValue) {
      this.$emit("update:data", { key: this.guide.key, value: newValue });
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.text = null;
      }
    }
    
  }
}
</script>

<style scoped>

</style>